import { Component, OnInit } from '@angular/core';
import { Usuario } from '../shared/index';
import { UsuarioService } from '../shared/service/usuario/usuario.service';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../shared/service/login/login.service';
import { Location } from '@angular/common';
import { UtilService } from '../shared/service/util/util.service';

@Component({
  selector: 'app-novo-usuario',
  templateUrl: './novo-usuario.component.html',
  styleUrls: ['./novo-usuario.component.css']
})
export class NovoUsuarioComponent implements OnInit {

  public usuario: Usuario = new Usuario();
  public regex: string;
  public organizacaoId: number;
  public selectedPerfil: string;
  public isGestor: boolean = false;
  public showSpinner: boolean = false;

  id: number;
  pageTitle: string = "Cadastrar Usuário";
  isUpdate: boolean = false;
  
  constructor(
    private usuarioService: UsuarioService,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private location: Location,
    private utilService: UtilService) {
    
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.organizacaoId = currentUser.organizacaoId;

    this.getUsuario();
  }

  getUsuario() {
    this.route.params.subscribe(params => {
      if (params["id"]) {
        this.id = params["id"];
        this.pageTitle = "Alterar Usuário";
        this.isUpdate = true;

        this.usuarioService.obterDadosUsuarioOrgPorId(this.id, this.organizacaoId).subscribe(
          res => {
            this.showSpinner = false;
            this.usuario = res;
            this.selectedPerfil = this.usuario.descricaoPerfilAcesso.toLocaleLowerCase();
            this.verificaUsuarioLogadoGestor();
          },
          err => {
            this.showSpinner = false;
            this.getError(err);
          }
        );
      } else {
        this.selectedPerfil = "";
        this.showSpinner = false;
      }
    });
  }

  verificaUsuarioLogadoGestor() {
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let usuarioId = currentUser.id;
    
    if (this.id == usuarioId && this.selectedPerfil == "gestor") {
      this.isGestor = true;
    }
  }

  ngOnInit() {
    this.regex = '^[a-zA-Z]+ [a-zA-Z].+';
  }

  salvar() {
    this.usuario.organizacaoId = this.organizacaoId;
    this.usuario.descricaoPerfilAcesso = this.selectedPerfil;
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.usuario.idUsuarioAlteracao = currentUser.id;
    this.usuario.emailUsuarioAlteracao = currentUser.email;

    if (this.usuario.id == null) {
      this.cadastrar();
    } else {
      this.atualizar();
    }
  }

  cadastrar() {
    this.showSpinner = true;
    this.usuarioService.cadastrar(this.usuario).subscribe(
      res => {
        this.utilService.showSuccess('Usuário cadastrado com sucesso');
        this.location.back();
      },
      err => {
        this.showSpinner = false;
        this.getError(err);
      }
    );
  }

  atualizar() {
    this.showSpinner = true;
    this.usuarioService.atualizar(this.usuario).subscribe(
      res => {
        this.utilService.showSuccess("Usuário alterado com sucesso");
        this.location.back();
      },
      err => {
        this.showSpinner = false;
        this.getError(err);
      }
    );
  }


  lowerCase(email: string) {
    if (email !== undefined)
      this.usuario.email = email.toLowerCase();
  }

  cancel() {
    this.location.back();
  }

  getError(error) {
    if (error.status === 401 || error.status === 403) {
      this.loginService.logout();
    } else {
      let err;

      if (error.status === 0) {
        err = 'Servidor indisponível!';
      } else {
        err = error.message || error;
      }
      this.utilService.showError(err);
    }
  }
}